export default {
  common: {
    appName: '허니배저 엔터테인먼트',
    confirm: '확인',
    cancel: '취소',
    submit: '제출',
    save: '저장',
    usernameRequired: '아이디를 입력해 주세요!',
    passwordRequired: '비밀번호를 입력해 주세요!',
    viewMore: '더보기',
    refreshSuccess: '새로고침 완료',
    noMore: '더 이상 없습니다',
    emptyData: '데이터가 없습니다',
  },
  footer: { home: '홈', lottery: '복권', game: '예약', video: '동영상', mine: '마이' },
  lang: { title: '언어 / Language', current: '현재 언어' },
  home: {
    recommendedTasks: '추천 작업',
    popularRanking: '인기 순위',
    hotRecommend: '인기 추천',
    playCount: '재생:{count}',
    noticeLoading: '불러오는 중...',
  },
  game: {
    hallTitle: '예약 홀',
    categoryAll: '전체',
  },
  choose: {
    title: '컴패니언',
    tabCities: '도시 목록',
    tabProcess: '절차 및 가격',
    privacyNotice: '본 플랫폼은 업계에서 가장 진짜 같은 컴패니언·비즈니스 동행·지역 데이트를 제공합니다. 모든 회원의 개인정보 보호를 위해 가입은 안내 담당자 연락 또는 시니어 회원의 실명 추천을 통해서만 가능합니다.',
    resourcesQ: '어떤 선택지가 있나요?',
    resourcesA: '인플루언서, 모델, 승무원, 신인 모델, 대학생까지 상상하는 모든 것을 준비해 드립니다.',
    scopeQ: '서비스 범위는?',
    scopeA: '같은 지역 무료 만남, 원하는 어떤 장소로든 전국 이동합니다. 국내 1~2선 도시는 현지 대응, 3선 도시도 안내 담당자를 통해 예약 가능합니다.',
    book: '예약',
    contactConcierge: '컨설턴트 또는 안내 담당자에게 연락해 주세요',
    cityNames: {
      beijing: '베이징',
      shanghai: '상하이',
      guangzhou: '광저우',
      shenzhen: '선전',
      nanjing: '난징',
      changsha: '창사',
      chongqing: '충칭',
      xian: '시안',
    },
  },
  lottery: {
    gameRecord: '작업 기록',
    orderList: '작업서',
    orderItemDetail: '1주 X{money}원 = {money}원',
    clearOrder: '주문 비우기',
    confirmSubmit: '확인 후 제출',
    availableBalance: '사용 가능 잔액',
    yuan: '원',
    currentPick: '현재 선택: ',
    amountPerBet: '1注당 금액: ',
    amountPlaceholder: '금액을 입력하세요',
    amountInvalid: '금액이 잘못되었습니다!',
    fillAmount: '금액을 입력해 주세요!',
    selectNumberFirst: '번호를 선택해 주세요!',
    insufficientBalance: '잔액이 부족합니다. 고객센터로 충전 문의해 주세요!',
    notSelected: '미선택',
    contactAdminForTask: '이 작업을 이용하려면 관리자에게 문의하세요!',
    drawSuccess: '추첨 결과 발표, 회차: {expect}',
    periodNumber: '회차',
    betUnit: '건',
    totalAmountLabel: '총 금액: ',
    totalCountLabel: '총 건수: ',
    drawResult: '추첨 번호',
    big: '대',
    small: '소',
    single: '홀',
    doubleNum: '짝',
    rules: {
      title: '게임 규칙',
      tipTitle: '게임 안내',
      tipDetail: '선택 가능한 합계 형태에서 번호를 골라 베팅합니다.',
      winTitle: '당첨 기준',
      winDetail: '세 추첨 번호의 합계가 11~18이면 대, 3~10이면 소입니다.',
      exampleTitle: '베팅 예시',
      exampleDetail: '베팅: 소 / 추첨 번호: 123 → 결과: 소',
    },
  },
  mine: {
    accountDetail: {
      kind: { recharge: '충전', withdraw: '출금', game: '베팅' },
    },
    withdraw: {
      amountLabel: '출금 금액 (원)',
      all: '전체',
      limitRule1: '1. 1회 한도: 최소 {min}원, 최대 {max}원',
      limitRule2: '2. 출금 횟수: 하루 최대 {num}회 출금',
      limitRule3: '3. 입금 시간: 보통 5분 내외, 가장 빠르면 2분 내로 입금됩니다',
      limitTitle: '한도 안내',
      balanceLabel: '잔액: ',
      submit: '지금 출금',
      amountInvalid: '올바른 금액을 입력해 주세요',
    },
    bindCard: {
      formLabel: '수령 카드 정보를 입력해 주세요',
      bankidLabel: '카드 번호',
      bankidPlaceholder: '실제 카드 번호를 입력하세요',
      bankLabel: '은행명',
      bankPlaceholder: '은행을 선택하세요',
      notice: '존중하는 고객님, 자금 안전을 위해 실명과 출금 비밀번호를 설정해 주십시오. 실명과 예금주명이 다를 경우 출금이 불가능합니다.',
      submit: '카드 연결 확인',
      bankidRequired: '카드 번호를 입력해 주세요!',
      bankRequired: '은행을 선택해 주세요!',
    },
    setbank: {
      title: '수령 카드 정보',
      addCard: '수령 카드 추가',
      tips: '안내: 큰 상업 은행으로 연결해 주세요. 수정이 필요하면 온라인 고객 서비스로 연락해 주세요.',
      setNameFirst: '이름을 설정한 후 은행 카드를 연결해 주세요!',
      setPayPasswordFirst: '출금 비밀번호를 설정한 후 은행 카드를 연결해 주세요!',
    },
    setPayPassword: {
      firstPrompt: '출금 비밀번호를 입력해 주세요',
      secondPrompt: '출금 비밀번호를 다시 입력해 주세요',
      incomplete: '입력해 주세요',
      mismatch: '두 비밀번호가 일치하지 않습니다!',
    },
    setLoginPassword: {
      oldPassword: '기존 비밀번호',
      oldPasswordPlaceholder: '기존 비밀번호를 입력하세요',
      newPassword: '새 비밀번호',
      newPasswordPlaceholder: '새 비밀번호를 입력하세요',
      confirmPasswordPlaceholder: '새 비밀번호를 다시 입력하세요',
      incomplete: '입력해 주세요!',
      mismatch: '두 비밀번호가 일치하지 않습니다',
    },
    setname: {
      nameLabel: '이름',
      namePlaceholder: '실명을 입력하세요',
      notice: '계정 보안을 위해 실명은 연결된 은행 카드 명의와 일치해야 합니다',
      alreadySet: '중복으로 설정하지 마세요!',
      nameRequired: '이름을 입력해 주세요!',
    },
    setsex: {
      male: '남성',
      female: '여성',
    },
    infomation: {
      avatar: '프로필 사진',
      chooseAvatar: '프로필 사진 선택',
      realName: '실명',
      notSet: '미설정',
      gender: '성별',
      unknown: '알 수 없음',
      bindInfo: '연결 정보',
      bound: '연결됨',
      none: '없음',
    },
    index: {
      recharge: '충전',
      withdraw: '출금',
      myWallet: '내 지갑',
      details: '상세',
      balanceLabel: '잔액: ',
      personalReport: '개인 리포트',
      accountDetail: '계정 상세',
      profileCenter: '개인 센터',
      notice: '공지사항',
      customerService: '온라인 상담',
      completeTaskFirst: '먼저 등록 작업을 완료해 주세요',
      contactServiceToRecharge: '충전은 온라인 상담으로 문의해 주세요',
      setPayoutCardFirst: '먼저 출금 카드를 설정해 주세요',
      featureDisabled: '아직 지원되지 않는 기능입니다',
      accountOffline: '계정이 종료되었습니다',
      loginRegister: '로그인/회원가입',
      loginHint: '로그인 후 확인',
    },
    setting: {
      basicInfo: '기본 정보',
      loginPassword: '로그인 비밀번호',
      payPassword: '결제 비밀번호',
      payPasswordAlreadySet: '결제 비밀번호가 이미 설정되었습니다!',
      signOut: '로그아웃',
    },
    gameRecord: {
      betAmount: '베팅 금액: {money}',
      betTime: '베팅 시간: {time}',
      settleTime: '정산 시간: {time}',
    },
    withdrawRecord: {
      amount: '출금 금액: {money}',
      desc: '출금 안내: {desc}',
      submitTime: '신청 시간: {time}',
      reviewTime: '심사 시간: {time}',
    },
    report: {
      profitLabel: '손익',
      formulaTip: '손익 = 당첨 금액 - 베팅 금액 + 충전 - 출금',
      playAmount: '베팅 금액',
      rechargeAmount: '충전 금액',
      withdrawAmount: '출금 금액',
      winAmount: '당첨 금액',
    },
    service: {
      contact: '지금 상담하기',
      slogan: '문의 사항은 언제든지 연락 주세요',
    },
  },
  video: {
    hallTitle: '비디오 극장',
    hotRecommend: '인기 추천',
    playCount: '재생:{count}',
    playCountSuffix: '{count}회 재생',
    rechargeToWatch: '충전 후 동영상을 시청해 주세요!',
  },
  recharge: {
    title: '충전',
    chooseCoin: '통화 선택',
    address: '입금 주소',
    copy: '주소 복사',
    copied: '복사되었습니다',
    amount: '충전 금액',
    uploadShot: '이체 스크린샷 업로드',
    submit: '충전 신청 제출',
    pending: '심사 대기',
    done: '입금 완료',
    rejected: '거부됨',
  },
  payMethod: {
    title: '수령 방법 선택',
    bankCard: '은행 카드',
    wallet: '암호화폐 지갑',
    unbind: '해제',
    bindNew: '새 주소 등록',
    confirmUnbind: '이 수령 방법을 해제하시겠습니까?',
    payPassword: '출금 비밀번호',
    wrongPassword: '출금 비밀번호가 올바르지 않습니다',
    chooseFirst: '먼저 수령 방법을 선택해 주세요',
  },
  router: {
    Index: { title: '홈' },
    Home: { title: '홈' },
    Choose: { title: '컴패니언' },
    List: { title: '컴패니언 목록' },
    Profile: { title: '컴패니언 상세' },
    Mine: { title: '마이페이지' },
    Video: { title: '동영상' },
    Game: { title: '게임' },
    Login: { title: '로그인' },
    Register: { title: '회원가입' },
    ServiceOnline: { title: '고객센터' },
    ServicePage: { title: '고객센터' },
    Setting: { title: '설정' },
    Infomation: { title: '기본 정보' },
    Setname: { title: '실명 변경' },
    Setsex: { title: '성별 변경' },
    SetPayPassword: { title: '결제 비밀번호' },
    SetLoginPassword: { title: '로그인 비밀번호' },
    Lottery: { title: '복권' },
    Notice: { title: '공지' },
    PlayVideo: { title: '동영상 재생' },
    Setbank: { title: '출금 카드 등록' },
    BindCard: { title: '출금 카드 등록' },
    Withdraw: { title: '출금' },
    Recharge: { title: '충전' },
    Personalreport: { title: '개인 리포트' },
    WithdrawRecord: { title: '출금 내역' },
    AccountDetail: { title: '계정 내역' },
    GameRecord: { title: '게임 기록' },
  },
  captcha: {
    placeholder: '이미지 캡차',
    refresh: '눌러서 새로고침',
    error: '캡차가 올바르지 않습니다',
    required: '캡차를 입력해 주세요',
  },
  login: {
    title: '로그인',
    usernamePlaceholder: '아이디를 입력해 주세요',
    passwordPlaceholder: '비밀번호를 입력해 주세요',
    forgotPassword: '비밀번호를 잊으셨나요?',
    noAccountRegister: '계정이 없으신가요? 지금 가입하세요',
    submit: '로그인',
  },
  register: {
    title: '회원가입',
    usernamePlaceholder: '아이디를 입력해 주세요(6-12자 영문 또는 숫자)',
    passwordPlaceholder: '로그인 비밀번호를 입력해 주세요(6-12자 영문 또는 숫자)',
    codePlaceholder: '초대 코드를 입력해 주세요',
    protocol: '\'계좌 개설 약관\'의 각 조항을 숙지하고 동의합니다',
    submit: '회원가입',
    codeRequired: '초대 코드를 입력해 주세요!',
    agreementRequired: '아래의 계좌 개설 약관에 동의해 주세요!',
  },
}
